﻿let reset = false;
const History = window.History; // Note: We are using a capital H instead of a lower h
function getActiveFuelTypes() {
    const greenButtons = $('[data-fuel-type] a.btn-green');
    const values = $.map(greenButtons, function (element, index) {
        return $(element).attr('value');
    });
    return values.join(',');
}

function handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    if (textDiv !== null && typeof textDiv !== 'undefined') {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.offsetHeight;

        console.log('TextDiv Height:', textDivHeight); // Debugging: Check the height

        // If 'textDiv' height is more than the height of 2 lines of text, add the toggle functionality
        if (textDivHeight > 50) {
            // Check if the toggle button already exists
            var existingToggleBtn = document.getElementById("body-copy-toggle");
            if (existingToggleBtn) {
                existingToggleBtn.remove(); // Remove existing button to avoid duplicates
            }

            // Dynamically create "Show More" button
            var toggleBtn = document.createElement("a");
            toggleBtn.id = "body-copy-toggle";
            toggleBtn.className = "text-left mt-3 mb-3 d-block";
            toggleBtn.href = "#";
            toggleBtn.innerHTML = "Show more +";
            textDiv.parentNode.appendChild(toggleBtn);

            toggleBtn.addEventListener("click", function (e) {
                e.preventDefault();
                if (parseFloat(textDiv.style.maxHeight.replace("px", "")) > 1.2 * 16) {
                    // If block is expanded 
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                } else {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                }
            });

            console.log('Toggle Button Added'); // Debugging: Confirm button is added
        }
    } else {
        console.log('TextDiv not found'); // Debugging: Check if textDiv is found
    }
}
function setManufacturer(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ManufacturerId') > 1) {
            const manId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ManufacturerId";
            })[0].split('=')[1];
            $.get("/cap-manufacturer-url/" + manId, function (response) {
                $("#ManufacturerName").val(response);
            });
        } else if (href.indexOf('Manufacturer') > 1) {
            const manufacturer = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "Manufacturer";
            })[0].split('=')[1];

            $("#ManufacturerName").val(manufacturer);
        }
    }
}

function setCarType(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('VehicleGroupId') > 1) {
            const vehicleGroupId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "VehicleGroupId";
            })[0].split('=')[1];
            $.get("/cap-car-type-url/" + vehicleGroupId, function (response) {
                $("#CarType").val(response);
            });
        } else if (href.indexOf('CarType') > 1) {
            const carType = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "CarType";
            })[0].split('=')[1];

            $("#CarType").val(carType);
        }
    }
}

function setModel(href) {
    if (href.indexOf('?') > 1) {
        const querystring = href.split('?')[1];
        const parts = querystring.split('&');
        if (href.indexOf('ModelGroupId') > 1) {
            const modelId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ModelGroupId";
            })[0].split('=')[1];
            const manufacturerId = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "ManufacturerId";
            })[0].split('=')[1];
            $.get("/cap-model-url/" + manufacturerId + "/" + modelId, function (response) {
                $("#ModelName").val(response);
            });
        } else if (href.indexOf('Model') > 1) {
            const model = $.grep(parts, function (el, index) {
                return el.split('=')[0] == "Model";
            })[0].split('=')[1];

            $("#ModelName").val(model);
        }
    }
}

//load the datatable for low res
function loadAsDataTable() {
    const table = $('#car-co2-table').DataTable({
        responsive: true,
        "ordering": false,
        "bPageinate": false,
        "bFilter": false,
        "bInfo": false,
        "bAutoWidth": false,
        "bLengthChange": false,
        "bSearchable": false,
        "iDisplayLength": -1,
        "fnDrawCallback": function (oSettings) {
            $('.dataTables_paginate').hide();
        }
    });
}

function checkIsDigitsOnly(e) {
    if (e.which !== 8 && e.which !== 0 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
        const id = $(e.target).attr('id');
        $('[data-error="' + id + '"]').html("digits only").show().fadeOut("slow");
        return false;
    }
    return true;
}

function onChangeFilters(event) {
    const currentDropdown = ($(this).attr("name"));
    if (currentDropdown === "ManufacturerId") {
        $("#ModelGroupId").val('');
        $("#ModelName").val('');
        $.get("/cap-manufacturer-url/" + $(this).val(), function (response) {
            $("#ManufacturerName").val(response);
            window.updateCarCO2Results();
        });
    } else if (currentDropdown === "ModelGroupId") {
        if (parseInt($(this).val()) > 0) {
            $.get("/cap-manufacturer-url/" + $('#ManufacturerId').val(), function (response) {
                $("#ManufacturerName").val(response);
            });
            $.get("/cap-model-url/" + $('#ManufacturerId').val() + "/" + $(this).val(), function (response) {
                $("#ModelName").val(response);
                window.updateCarCO2Results();
            });
        } else {
            $("#ModelName").val('');
            window.updateCarCO2Results();
        }
    } else if (currentDropdown === "VehicleGroupId") {
        $("#ModelGroupId").val('');
        if (parseInt($('#VehicleGroupId').val()) > 0) {
            $.get("/cap-car-type-url/" + $('#VehicleGroupId').val(), function (response) {
                $("#CarType").val(response);
                window.updateCarCO2Results();
            });
        } else {
            $("#CarType").val('');
            window.updateCarCO2Results();
        }
    } else {
        window.updateCarCO2Results();
    }
}

function updateFuelTypes(event) {
    $(event.target).toggleClass('btn-green').toggleClass('btn-primary');
    event.preventDefault();
    window.updateCarCO2Results();
}

function buildUpQueryString(data) {
    let queryString = "";

    if (queryString.length > 0) queryString += "&";
    if (parseInt(data.VehicleGroupId) > 0) {
        queryString += "CarType=" + data.CarType;
    } else {
        queryString += "CarType=";
    }
    if (queryString.length > 0) queryString += "&";
    queryString += "Manufacturer=" + data.Manufacturer;

    if (queryString.length > 0) queryString += "&";
    queryString += "Model=" + data.Model;

    if (data.Page > 1) {
        if (queryString.length > 0) queryString += "&";
        queryString += "P=" + data.Page;
    }

    if (queryString.length > 0) queryString += "&";
    queryString += "CO2To=" + data.CO2To;

    if (queryString.length > 0) queryString += "&";
    queryString += "MpgFrom=" + data.MpgFrom;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortBy=" + data.SortBy;

    if (queryString.length > 0) queryString += "&";
    queryString += "SortDesc=" + data.SortDesc;

    if (queryString.length > 0) queryString += "&";
    queryString += "FuelType=" + data.FuelType;
    return "?" + queryString;
}

function getData(page) {
    const vehicleGroupId = $('#VehicleGroupId').val();
    const manufacturerId = $('#ManufacturerId').val();
    const modelGroupId = $('#ModelGroupId').val();
    const manufacturerName = $("#ManufacturerName").val();
    const modelName = $("#ModelName").val();
    const carType = $("#CarType").val();
    const co2To = $('#CO2To').val();
    const mpgFrom = $('#MpgFrom').val();
    const sortBy = $('#SortBy').val();
    const sortDesc = $('#SortDesc').val();
    const fuelType = getActiveFuelTypes();

    return {
        VehicleGroupId: vehicleGroupId,
        ManufacturerId: manufacturerId,
        ModelGroupId: modelGroupId,
        Manufacturer: manufacturerName,
        Model: modelName,
        CarType: carType,
        MpgFrom: mpgFrom,
        CO2To: co2To,
        SortBy: sortBy,
        SortDesc: sortDesc,
        FuelType: fuelType,
        P: page
    };
}

function updateResultsLogic(page) {
    const data = getData(page);
    History.pushState(data, $('title').html(), location.pathname + buildUpQueryString(data));
}

function getPage(href) {
    const querystring = href.split('?')[1];
    const parts = querystring.split('&');
    return $.grep(parts, function (el, index) {
        return el.split('=')[0] == "p";
    })[0].split('=')[1];
}

function pageData(event) {
    event.preventDefault();
    if ($(this).attr('href') === undefined)
        return;
    const page = getPage($(this).attr('href'));
    updateResultsLogic(page);
}

function applyResultsSortArrows() {
    const sortBy = $('#SortBy').val();
    $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-asc.png') no-repeat right center;");
    const sortDesc = $('#SortDesc').val();
    if (sortDesc.toLowerCase() === "true") {
        $("[data-co2-sort=" + sortBy + "]").attr("style", "background: url('/Content/Images/top-desc.png') no-repeat right center;");
    }
}

function sortResults(event) {
    event.preventDefault();
    const newSortBy = $(this).data('co2-sort');
    const sortByEl = $('#SortBy');
    const sortDescEl = $('#SortDesc');
    const sortBy = sortByEl.val();
    sortByEl.val(newSortBy);
    const sortDesc = sortDescEl.val();
    if (sortBy != newSortBy || sortDesc.toLowerCase() === "true") {
        sortDescEl.val("false");
    } else {
        sortDescEl.val("true");
    }
    window.updateCarCO2Results();
}

function showHideDetail() {
    const $this = $(this);
    const currentText = $.trim($this.text());
    const row = $this.parents('tr');
    let alreadyExist = row.next('tr.spacer');
    if (window.isViewportLessThan('md')) {
        alreadyExist = row.parent().parent().next('tr.spacer');
    }
    const rowHeight = row.height();
    if (currentText == "View data") {
        $this.text('Hide data');
        if (alreadyExist.length < 1) {
            if (window.isViewportGreaterThanOrEqualTo('xl')) {
                row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
            } else if (window.getViewportSize()=='lg') {
                if (rowHeight > 40) {
                    row.after('<tr class="spacer"><td colspan="6" height="110"></td></tr>');
                } else {
                    row.after('<tr class="spacer"><td colspan="6" height="140"></td></tr>');
                }
            } else if (window.getViewportSize()=='md') {
                row.after('<tr class="spacer"><td colspan="6" height="155"></td></tr>');
            } else {
                row.after('<tr class="spacer"><td colspan="6" height="220"></td></tr>');
            }
        }
    } else {
        $this.text('View data');
        if (alreadyExist.length > 0) {
            row.next('tr.spacer').remove();
        }
        if (window.isViewportLessThan('md')) {
            $('#car-co2-table_wrapper tr.spacer').remove();
        }
    }
}

function markAsLoading() {
    $('#co2-calculator-results-container').text('').html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
}

function reloadQuery() {
    const State = History.getState();
    $.ajaxSetup({ cache: false });
    $.get('/car-co2-calculator/query', State.data, function (response) {
        $('#co2-calculator-query-container').replaceWith(response);
        handleBodyCopyToggle();
    });
}


function updateState() {
    markAsLoading();
    reloadQuery();
    const State = History.getState();
    $.get('/car-co2-calculator/results', State.data, function (response) {
        $('#co2-calculator-results-container').replaceWith(response);
        $("html, body").animate({ scrollTop: $("#co2-calculator-results-container").offset().top - 90 }, 100);
        loadAsDataTable();
        applyResultsSortArrows();
        if (reset) {
            $('[data-no-results]').hide();
            $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
            reset = false;
        }
    });
}

export function setupCarCO2Calculator() {
    const page = $('[data-co2-calculator]').length;
    if (!page) {
        return;
    }

    const currentUrl = window.location.href;
    setManufacturer(currentUrl);
    setCarType(currentUrl);
    setModel(currentUrl);
    $('#initial-result').html("<div class='alert alert-warning'>Your results will appear here - choose either a car type or make above to start your search</div>");
    $('[data-no-results]').hide();
    loadAsDataTable();
    $(document).on("click", "[data-view-detail]", showHideDetail);
    $(document).on('keypress', "[data-digits-only]", checkIsDigitsOnly);
    $(document).on('change', '[data-co2-calculator] input, [data-co2-calculator] select', onChangeFilters);
    $(document).on('keypress', '[data-co2-calculator] input', function (e) {
        if (e.keyCode === 13) {
            onChangeFilters();
            return false;
        }
    });
    $(document).on("click", "[data-derivative]", function (e) {
        e.preventDefault();
        $(this).parents('tr').find('[data-view-detail]').trigger("click");
    });
    $(document).on('click', '[data-fuel-type] a', updateFuelTypes);
    $(document).on('click', '#co2-calculator-results-container .pagination a', pageData);
    applyResultsSortArrows();
    $(document).on("click", "[data-co2-sort]", sortResults);
    $(document).on("click", "[data-reset-button]", function (event) {
        event.preventDefault();
        History.pushState({}, $('title').html(), location.pathname);
        reset = true;
    });

    window.updateCarCO2Results = function () {
        updateResultsLogic(1);
    }

    History.Adapter.bind(window, 'statechange', updateState);
}